<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  main {
    color: colors.get(textLighterBlack);
    width: 100%;
    height: 100svh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: utils.in_rem(8px);
    text-align: center;

    span {
      /* Should just use h3 but not all pages having theme.scss partitioning by data-sw-ds */
      @include mixins.h3();
      margin-top: utils.in_rem(8px);
    }
  }
</style>

<script>
  import { conversationsLicenses } from "@sourcewhale/shared/src/assets/js/src/general/licenses";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";

  let { licenses = [] } = $props();

  const { meta } = userStore;

  const licenseToTitle = {
    outreach: "Outreach",
    extension: "Sourcing",
    data: "Data Refresh",
    inboxAgent: "Inbox Agent",
    notetaker: "Notetaker",
    projects: "Projects",
  };

  let titles = $derived.by(() => {
    const ret = licenses
      .map((license) => licenseToTitle[license])
      .filter(Boolean);
    const conversationsSet = new Set(conversationsLicenses);
    if (licenses.some((license) => conversationsSet.has(license))) {
      ret.push("Conversations");
    }
    return ret;
  });

  let msg = $derived(
    titles.length === 1
      ? `The ${titles[0]} License is required to access this page`
      : `You need one of the following licenses to access this page: ${titles.join(
          ", "
        )}`
  );

  const icons = {
    outreach: "fa-regular fa-bullhorn",
    extension: "fa-regular fa-puzzle-piece",
    data: "fa-regular fa-refresh",
    ausConversations: "fa-regular fa-phone",
    euConversations: "fa-regular fa-phone",
    ukConversations: "fa-regular fa-phone",
    usConversations: "fa-regular fa-phone",
    inboxAgent: "fa-regular fa-envelope",
    notetaker: "fa-regular fa-video",
  };

  let person = $derived(
    $userStore?.isAdmin ? "Account Manager" : "SourceWhale admin"
  );
</script>

<main>
  {#if $meta.fetching || !$meta.firstFetchDone}
    <IconScale
      class="fa-regular fa-circle"
      size="xl"
      backgroundColor="interfaceSwGrey_10"
      color="interfaceSwGrey_20"
      skeleton={true}
    />
    <span style="width: 300px; height: 1.5rem;" class="skeleton"></span>
    <p style="width: 200px; height: 1rem;" class="skeleton"></p>
  {:else}
    {#if icons[licenses[0]]}
      <IconScale
        class={icons[licenses[0]]}
        size="xl"
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
      />
    {/if}
    <span>{msg}</span>
    <p>Speak to your {person} to get set up</p>
  {/if}
</main>
